/**
 * Resources Listing: continuous scroll.
 *
 * The section renders page 1 server-side, so the page works with no JS and
 * stays crawlable. This script fetches subsequent pages through Shopify's
 * section-rendering endpoint (?section_id=<section.id>, set up in the
 * section's Liquid) and appends their cards into the existing grid, either
 * automatically as the "Load more" link scrolls into view, or immediately
 * if someone clicks it.
 *
 * If a fetch fails, the visible "Load more" link is left pointing at a real
 * paginated URL, so the visitor can still get to the next page by clicking
 * and triggering a normal navigation.
 */
document.addEventListener('DOMContentLoaded', function () {
  const grid = document.querySelector('.resources-grid');
  const loadMoreEl = document.querySelector('[data-resources-load-more]');

  if (!grid || !loadMoreEl) return;

  const link = loadMoreEl.querySelector('[data-resources-load-more-link]');
  const spinner = loadMoreEl.querySelector('[data-resources-load-more-spinner]');

  let isLoading = false;

  function setLoading(loading) {
    isLoading = loading;
    if (link) link.hidden = loading;
    if (spinner) spinner.hidden = !loading;
  }

  function loadNextPage() {
    if (isLoading) return;

    const nextUrl = loadMoreEl.getAttribute('data-next-url');
    if (!nextUrl) return;

    setLoading(true);

    fetch(nextUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Resources: load-more request failed with status ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCards = doc.querySelectorAll('.resources-grid > .resources-card');
        const newLoadMore = doc.querySelector('[data-resources-load-more]');

        newCards.forEach(function (card) {
          card.classList.add('resources-card--entering');
          grid.appendChild(card);
        });

        // Let the appended cards paint in their hidden state first, then
        // remove the class on the next frame so the opacity transition
        // actually runs instead of the cards just appearing instantly.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            newCards.forEach(function (card) {
              card.classList.remove('resources-card--entering');
            });
          });
        });

        const newNextUrl = newLoadMore ? newLoadMore.getAttribute('data-next-url') : null;
        if (newNextUrl) {
          loadMoreEl.setAttribute('data-next-url', newNextUrl);
        } else {
          // No further pages: nothing left to observe or click.
          loadMoreEl.remove();
        }
      })
      .catch(function (error) {
        // Fail open: leave the manual link in place and usable as a normal
        // navigation to the next page, rather than leaving the visitor stuck.
        console.error(error);
      })
      .finally(function () {
        if (document.body.contains(loadMoreEl)) {
          setLoading(false);
        }
      });
  }

  if (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      loadNextPage();
    });
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNextPage();
        });
      },
      { rootMargin: '600px 0px' }
    );
    observer.observe(loadMoreEl);
  }
  // No IntersectionObserver support: the "Load more" link above still works
  // as a normal click-to-fetch trigger, and as a real link if JS fails
  // entirely.
});
